import materialize from 'materialize-css'
import angular from 'angular'
import uirouter from 'angular-ui-router'
import angularmaterialize from 'angular-materialize'
import swal from 'sweetalert'
import 'angular-sweetalert'

import 'scss/main.scss'
import routing from './app.routes'
import run from './app.run'
import ShellService from './shell.service.js'
import ShellController from './shell.controller.js'
import home from 'components/home'
import session from 'components/session'

angular.module('app', [uirouter, angularmaterialize, 'oitozero.ngSweetAlert', home, session])
  .config(routing)
  .run(run)
  .service('ShellService', ShellService)
  .controller('ShellController', ShellController)